import { ChakraProvider, Theme } from '@chakra-ui/react';
import type { ReactNode } from 'react';

import { system } from '../../theme/system';

export function Provider({ children }: { children: ReactNode }) {
  return (
    <ChakraProvider value={system}>
      <Theme appearance="dark">{children}</Theme>
    </ChakraProvider>
  );
}